<!-- 
Table header for tables that have paging and / or searching.

Shows the search criteria, standard table buttons (export, refresh etc) and the table pager.
-->
<template>
  <v-container fluid align-content-center class="paging-container pl-3 pr-2 pt-3 pb-0">
    <v-layout row wrap>
      <v-flex shrink>
        <div class="our-table-header-text">
          <span :class="{'criteria-loading': listing.loading}">
            {{ listing.criteriaInfo.description }}
          </span>
          <criteria-chips 
            v-if="criteriaMutation && searchFilters"
            :criteria="listing.criteria" 
            :criteria-mutation="criteriaMutation" 
            :search-filters="searchFilters" 
            @changed="$emit('update:criteria')"
          />
        </div>
      </v-flex>
      <v-spacer/>
      <v-flex grow class="text-xs-right">
        <table-icon-buttons
          :has-export="hasExport"
          :has-export-to-json="hasExportToJson"
          :has-expanders="hasExpanders"
          :expand-multiple="expandMultiple"
          @click="$emit('click:' + $event)"
        />
        <table-pager v-if="listing.paging" :paging="listing.paging" @update:pageNumber="$emit('update:pageNumber', $event)" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import TableIconButtons from "./TableIconButtons.vue";
import CriteriaChips from "./CriteriaChips.vue";
import TablePager from "./TablePager.vue";

export default {
  components: { TableIconButtons, CriteriaChips, TablePager },
  props: {
    listing: {
      type: Object,
      required: true
    },
    searchFilters: {
      type: Array,
      default: null
    },
    criteriaMutation: {
      type: String,
      default: null
    },
    hasExport: {
      type: Boolean,
      default: false
    },
    hasExportToJson: {
      type: Boolean,
      default: false
    },
    hasExpanders: {
      type: Boolean,
      default: false
    },
    expandMultiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu: false
    };
  },
  computed: {
    page() {
      return this.listing.paging ? this.listing.paging.page : 1;
    },
    pages() {
      return this.listing.paging ? this.listing.paging.pages : 1;
    }
  },
  methods: {
    gotoPage: function(page) {
      var value = parseInt(page);
      if (value && value > 0 && value <= this.pages) {
        this.$emit("update:pageNumber", value);
      }
    }
  }
};
</script>

<style lang="scss">
.our-table-header-text {
  cursor: default;
  display: inline-block;
  line-height: 38px;
  position: relative;
  top: 1px;
}
.criteria-loading {
  color: lightgray;
}
</style>